import React, { useState } from 'react'
import { Grid, Tab, Tabs } from '@mui/material'
import ParametersScreen from './ParametersScreen'
import BoardsScreen from './BoardsScreen'
import i18n from 'simple-react-i18n'
import ObjectivesScreen from './ObjectivesScreen'

const PARAMS = 0
const TAB_PESTICIDE = 1
const OBJ = 2

const CatchmentsOptionApp = ({}) => {
    const [tab, setTab] = useState(PARAMS)

    return (
        <Grid padding={'1rem'} >
            <Tabs
                value={tab}
                onChange={(e, newValue) => setTab(newValue)}
                variant='fullWidth'
            >
                <Tab label={ i18n.parameters } />
                <Tab label={ i18n.pesticidesBoards } />
                <Tab label={ i18n.objectives } />
            </Tabs>

            {tab === PARAMS && (
                <ParametersScreen/>
            )}
            {tab === TAB_PESTICIDE && (
                <BoardsScreen/>
            )}
            {tab === OBJ && (
                <ObjectivesScreen />
            )}
        </Grid>
    )
}

export default CatchmentsOptionApp